import html2pdf from 'html2pdf.js';
import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router';
import { Toast } from "primereact/toast";
import { Tablescom } from '../../components/tablescomp';
import { Tag } from 'primereact/tag';
import Bredcrum from '../../components/bredcrum';
import { Titlebar, Searchbox, Shipmentstatus,Confirmdelete2 } from '../../components/fieldsComp';
import { BrowserRouter, Routes, Route, useNavigate } from "react-router";
import { productservices } from '../../services/productServices';
import { purchaseorderservices } from '../../services/purchaseorderService';
import { Dialog } from 'primereact/dialog';
import '../../assets/recipttemplate.css';
import { FaShippingFast } from 'react-icons/fa';
import { exportToExcel } from '../../helpers/exporttoexcel';
import { stringtodate } from '../../helpers/dateconverter';

import { TabMenu } from 'primereact/tabmenu';
import { MdLoop } from "react-icons/md";
import { Calendar } from 'primereact/calendar';
import { useFormikContext, useFormik, Field, Formik, Form, FieldArray } from 'formik';
import { StockServices } from '../../services/stockServices';
import { SplitButton } from 'primereact/splitbutton';
import { Message } from 'primereact/message';

const Purchaseorder = () => {
  const navigate = useNavigate();
  const [results, setResults] = useState([]);
  const [userloaded, setUserLoaded] = useState(true);
  const [visible, setVisible] = useState(false);
  const [quickbookconnected, setQuickbookconnection] = useState(false);
  const [purchsedialog, setPurchasedialog] = useState(false);
  const [purchseordersdata, setPurchaseorderdata] = useState({});
  const [status, setStatus] = useState('');
  const [quickFilterText, setQuickFilterText] = useState('');
  const [shipmentpopup, setshipmentpopup] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [damagedstockdata, setDamagedstockdata] = useState({});
  const [componentdetail, setComponentdetail] = useState({});
  const [filter, setfilter] = useState({ 'fromdate': '', 'todate': '' });
  const pdfRef = useRef();
  const toast = useRef();
  const [confirmarchivestate,setconfirm] = useState({
    'popvisible' : false,
    'id':'',
    'stocktype':''
  });
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [colDefs, setColDefs] = useState([
    {
      headerName: "SR NO", field: "id", width: 80, cellRenderer: (params) => {
        return params.node.rowIndex + 1; // +1 to start from 1 instead of 0
      }
    },
    { headerName: "Po Number", field: "ponumber", tooltipField: "ponumber" },
    { headerName: "Po Date", field: "stringpodate", width: 150 },
    { headerName: "Expected Delivery date", field: "expecteddldate", width: 150 },
    { headerName: "Ship Ref No", field: "shipment_reference"},
    {
      headerName: "Status", field: "status", editable: true,
      cellEditor: 'agSelectCellEditor',
      cellEditorParams: {
      values: ["pending", "dispatched", "partially_received", "fully_received"]
    },

      cellRenderer: (params) => {
        return (<>
          <select className='rounded w-100 text-primary dropdown-custom-style' value={params.getValue()} onChange={(e) => { setpurchaseOrder(params, e.target.value);setPurchasestatus({value:e.target.value,object:params.data}); }} disabled={params.getValue() == 'closed' ? true : false}>
            <option value="open">Open</option>
            <option value="pending">Pending</option>
            <option value="dispatched">Dispatched/Approved</option>
            <option value="in_transit">IN Transit</option>
            <option value="partially_received">Partially Received</option>
            <option value="fully_received">Fully Received</option>
            <option value="closed">Closed</option>
          </select>
          {/* <Tag severity='danger' value={params.data.status}></Tag> */}
        </>);
      }
    },
    {
      headerName: "Items Count", field: "itemscnt", width: 100, cellRenderer: (params) => {
        return (params.getValue());
      }
    },
    {
      headerName: "Ship Status", field: "shipmentstatus", width: 100, cellRenderer: (params) => {
        return (<Shipmentstatus status={params.getValue()} />);
      }
    },
    
    {
      headerName: "Action",
      cellRenderer: (params) => {
         
        let dataobj = {
          label: '',
          icon: null,
          fun: () => {},
        };

        if (
          params.data.status !== 'open' &&
          params.data.status !== 'pending' &&
          params.data.status !== 'closed'
        ) {
          if (params.data.shipmentispresent === 'present') {
            dataobj.label = 'Edit Shipment';
            dataobj.icon = ( <>&nbsp;<FaShippingFast /></> );
            dataobj.fun = () => navigate(`/editshipment/${params.data.shipment_id}`, {
              state: { shipment: params.data },
            });
          } else {
            dataobj.label = 'Create Shipment';
            dataobj.icon = ( <>&nbsp;&nbsp;<FaShippingFast /></> );
            dataobj.fun = () => navigate('/addshipment', { state: params.data });
          }
        }
        return (
          <>
            {params.data.status != 'open' && params.data.status != 'pending' && params.data.status != 'closed' && params.data.shipmentispresent == 'present' || params.data.shipmentstatus == 'delivered' ?
              (
                <></>
              ) : (<button class="btn  btn-xs btn-primary" disabled={(params.data.status != 'open' && params.data.status != 'pending') ? true : false} onClick={() => navigate('/editpurchaseorder', { state: params.data })}>
                <i class="icon icon-note  color-primary"></i>
              </button>)}
            &nbsp;
            {
               (params.data.status != 'open' && params.data.status != 'pending') ? <></> : (<button class="btn btn-danger btn-xs btn-white btn-border-none"
              disabled={(params.data.status != 'open' && params.data.status != 'pending') ? true : false} onClick={() => { Confirmdelete(params.data.ponumber) }}><i class="icon text-white icon-trash  color-danger"></i></button>) 
            }
            
            &nbsp;
            <button class="btn btn-success btn-xs btn-white btn-border-none"  onClick={() => { setVisible(true); getpurchaseOrderspecific(params.data.ponumber) }}><i class="icon text-white icon-eye  color-success"></i></button>
            &nbsp;

             <SplitButton label="Save" icon="icon icon-plus" dropdownIcon="icon icon-plus" model={[
          {
            label: 'Receipt',
            icon: 'fa fa-receipt',
            command: () => {
                navigate('/showpurchaseorder', { state: params.data })
            }
          },
          {
            label: ' Send to quickbook',
            icon: <MdLoop className='text-success'/>,
            command: () => {
                navigate('/showpurchaseorder', { state: params.data })
            }
          },
          {
              label:dataobj.label,
              icon: dataobj.icon,
              command: () => {
                  dataobj.fun()
              }  
          },

        
         ]} 
        />

            

            

          </>

        );
      }
    }
  ]);
  const [purchasestatus, setPurchasestatus] = useState({'value':'','object':{}});

  const save = () => {
        // toast.current.show({ severity: 'success', summary: 'Success', detail: 'Data Saved' });
  };
  const items1 = [
        {
            label: 'Update',
            icon: 'pi pi-refresh',
            command: () => {
                toast.current.show({ severity: 'success', summary: 'Updated', detail: 'Data Updated' });
            }
        },
        {
            label: 'Delete',
            icon: 'pi pi-times',
            command: () => {
                toast.current.show({ severity: 'warn', summary: 'Delete', detail: 'Data Deleted' });
            }
        },
        {
            label: 'React Website',
            icon: 'pi pi-external-link',
            command: () => {
                window.location.href = 'https://reactjs.org/';
            }
        },
        {
            label: 'Upload',
            icon: 'pi pi-upload',
            command: () => {
                //router.push('/fileupload');
            }
        }
    ];

  

  const items = [
    {
      label: 'All Orders',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('all'),
      // template: (item) => itemRenderer(item, 0)
    },
    {
      label: 'Open',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('open'),
      //  template: (item) => itemRenderer(item, 1)
    },
    {
      label: 'Dispatched',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('dispatched'),
      //  template: (item) => itemRenderer(item, 2)
    },
    {
      label: 'Partially-Received',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('partially_received'),
      //  template: (item) => itemRenderer(item, 3)
    },
    {
      label: 'Fully-Received',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('fully_received'),
      //  template: (item) => itemRenderer(item, 3)
    },
    {
      label: 'Closed',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('closed'),
      //  template: (item) => itemRenderer(item, 3)
    },

    {
      label: 'Archived',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('archive'),
      //  template: (item) => itemRenderer(item, 3)
    }
  ];


  function handleStockFilter(status) {
    getpurchaseOrder(status);
  }


  useEffect(() => {
    getpurchaseOrder('all', currentPage, pageSize);
    checkconnection();
  }, [filter, currentPage, pageSize]);


  function Confirmdelete(ponumber){
      setconfirm({
      'popvisible' : true,
      'id':ponumber,
      'stocktype':''
    });
  }

  function Cancel(){
     setconfirm({
      'popvisible' : false,
    });
  }

  function deletepurchaseorder(ponumber) {
    purchaseorderservices.deletepurchaseorder(ponumber).then((response) => {
      if (response.status == 200) {
        toast.current.show({ severity: 'success', summary: 'Purchase order', detail: response.data.data });
        getpurchaseOrder();
      } else {
        toast.current.show({ severity: 'error', summary: 'Purchase order', detail: response.data.data });
      }
    }).catch((error) => {

    })
  }


  function setpurchaseOrder(rowdata, value) {
    // setUserLoaded(true);
    let objdata = {
      "rowdata": rowdata.data,
      "value": value
    };
    

    purchaseorderservices.setpurchaseOrder(objdata).then((response) => {
      if (response.status == 200) {
        getpurchaseOrder();
      } else {
        toast.current.show({ severity: 'error', summary: 'Purchase order', detail: response.data.data });
      }
    }).catch((error) => {
      toast.current.show({ severity: 'error', summary: 'Purchase order', detail: "Error" });
      //  setResults([]);
      //  setUserLoaded(false);
    });
  }

  function getpurchaseOrder(status, page, pageSize) {
    setUserLoaded(true);
    purchaseorderservices.getpurchaseOrder('all', { status: status, fromdate: filter.fromdate, todate: filter.todate }, page, pageSize).then((response) => {
      if (response.status == 200) {

        setResults(response.data.data.data);
        setUserLoaded(false);
        setTotalRows(response.data.data.total);
        setCurrentPage(response.data.data.current_page);
      } else {
        setResults([]);
        setUserLoaded(false);
      }
    }).catch((error) => {
      setResults([]);
      setUserLoaded(false);
    });
  }

  const getRowClass = params => {
    if (params.data.status === 'dispatched') {
      return 'dispatched';
    } else if (params.data.status === 'partially_received') {
      return 'partially_received';
    } else if (params.data.status === 'fully_received') {
      return 'fully_received';
    }
    return '';
  };

  const handleExport = () => {
    exportToExcel({ data: results, filename: 'Purchase Order' });
  }


  const quickbookconnect = () => {
    // console.log("quick book connect");  
    purchaseorderservices.quickbookconnect().then((response) => {
      if (response.status == 200) {
        // console.log(response.data.data);
        window.location.href = `${response.data.data}`;
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  const checkconnection = () => {
    purchaseorderservices.checkconnection().then((response) => {
      if (response.status == 200) {
        console.log(response.data.data);
        setQuickbookconnection(true);
      } else {
        setQuickbookconnection(false);
      }
    }).catch((error) => {
      console.log(error);
      setQuickbookconnection(false);
    });
  }

  const getpurchaseOrderspecific = (ponumber) => {
    purchaseorderservices.getpurchaseOrderspecific(ponumber).then((response) => {
      if (response.status == 200) {
        //  console.log(response.data.data);
        setPurchaseorderdata(response.data.data);
      } else {
        setPurchaseorderdata([]);
      }
    }).catch((error) => {
      setPurchaseorderdata([]);
    })
  }

  const stockupdatemodel = (value) => {
    setshipmentpopup(true)
    setComponentdetail(value);
    console.log("stock update model");
    // console.log(value);
    let skucode = value.componentSkuCode;
    let ponumber = value.ponumber;
   

    StockServices.getdamagedstock(skucode, ponumber).then((response) => {
      if (response.status == 200) {
        // console.log(response.data.data);   
        setDamagedstockdata(response.data.data);
        setComponentdetail((prevData) => {
          return {
            ...prevData,
            // quantity: response.data.data.quantity,
            damaged_quantity: response.data.data.damaged_quantity,
            stock_type: response.data.data.stock_type,
            damage_reason: response.data.data.damage_reason,
            damage_comment: response.data.data.damage_comment,
          }
        })
      } else {
        console.log("get damaged data");
        setDamagedstockdata({});
      }
    }).catch(() => {
      console.log("Error");
    })
  }

  const moredetail = () => {
    let maindata = [];
    let items = [];
    maindata = (<tr>
      <td>{purchseordersdata.ponumber}</td>
      <td>{purchseordersdata.shipment_reference}</td>
      <td> <Shipmentstatus status={purchseordersdata.shipment_status} /></td>
      <td>{purchseordersdata.shopname}</td>
      <td>{purchseordersdata.warehouse_location}</td>
    </tr>)
    purchseordersdata?.items?.forEach((value, index) => {
      items.push(
        <tr>
          <td>{value.component}</td>
          <td>{value.quantity} <span className='text-success'>({value.unit})</span></td>
          <td>{value.currency_symbol} &nbsp;{value.unitprice}</td>
          <td>{value.currency_symbol} &nbsp;{value.totalcost}</td>
          <td>{value.damaged_quantity}</td>
          <td>{value.actualquantity}</td>
          <td>
            {(value.quantity <= 0) || (purchseordersdata.shipment_status !== 'delivered') ? (
              <></>
            ) : (
            <>
            <button className='btn btn-secondary' title='Update Damage Stock' onClick={() => { stockupdatemodel(value); }}>Update damage stock</button>  
             &nbsp; &nbsp; 
            <button className='btn btn-warning' title='Update Stock' onClick={() => { navigate('/quickupdatestock',{state:{"value":value,'purchaseorder':'yes'}})}}><i className='fa fa-angle-right text-white'></i></button>
            </>)}
          </td>
        </tr>
      )
    });
    let obj = {
      'maindata': maindata,
      'items': items
    };

    return obj;
  }


  const monthfilter = (value) => {
    // let date = stringtodate(value);
    let date = value;
    getpurchaseOrder('all', { date: date });
  }

  const createquickbookpurchaseorder = (data) => {
    purchaseorderservices.createquickbookpurchaseorder(data.ponumber).then((response) => {
      if (response.status == 200) {

      } else {

      }
    }).catch((error) => {

    })
  }

  const handleSave = (values) => {
    // console.log("handle save");
    // console.log(values);
    values.total_qty = componentdetail.quantity;
    StockServices.updatedamagedstock(values).then((response) => {
      if (response.status == 200) {
        toast.current.show({ severity: 'success', summary: 'Stock', detail: response.data.data });
        getpurchaseOrderspecific(values?.purchase_order_id);
        setshipmentpopup(false);
      } else {
        // console.log("quick update sdsds"); 
        toast.current.show({ severity: 'error', summary: 'Stock', detail: response.data.data });
        // setshipmentpopup(false); 
      }
    }).catch((error) => {
      console.log("quick update sdsds");

    })
  }


  const handleNext = () => {
    if (currentPage < Math.ceil(totalRows / pageSize)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const onPaginationChanged = (params) => {
    const gridApi = params.api;
    const newPage = gridApi.paginationGetCurrentPage() + 1;
    if (newPage !== currentPage) {
      setCurrentPage(newPage);
    }
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(1);           // reset to page 1
    getpurchaseOrder('all', 1, newSize);
  };


  const message = () =>{
     return purchasestatus.value == 'dispatched' ? <Message
          severity="info"
          content={
            <div className="flex justify-between items-center w-full">
              <span>Please update the shipping detail from the button given.</span>
              <button
                label="Update Shipping"
                icon="pi pi-refresh"
                className="ml-3 p-button-sm btn btn-info"
                onClick={() =>{navigate('/addshipment', { state: purchasestatus.object })}}
              >Update Shipping</button>
            </div>
          }
        /> : <></>
  }
  return (
    <>
      {/* <Bredcrum title={'Purchase Order'} divider={false} /> */}
      <Toast ref={toast} />
      <div class="row">
        <div className='col-md-12 mb-2 mt-2'>
          <div className='flex-box flex-between'>
            <div className=''>
              <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color ' onClick={() => navigate('/createpurchaseorder')}>Create Purchase Order</button>
              &nbsp; &nbsp;
              {quickbookconnected ? (<button className='btn btn-success rounded-pill connected-api-style' onClick={() => quickbookconnect()}>Connected</button>) : (<button className='btn rounded-pill connecting-api-style' onClick={() => quickbookconnect()}>Connect QuickBook</button>)}

            </div>
            <Searchbox value={quickFilterText} onChange={(e) => setQuickFilterText(e.target.value)} />
          </div>
        </div>
        <Dialog visible={purchsedialog} position='top' modal style={{ width: '80rem' }} onHide={() => { if (!purchsedialog) return; setPurchasedialog(false); }}>

        </Dialog>

        <Dialog visible={visible} position='top' modal style={{ width: '95rem' }} onHide={() => { if (!visible) return; setVisible(false); }}>
          <div class="container">
            <table className='table-bordered'>
              <tbody>
                <tr>
                  <th colSpan={4}>
                    <h3 className='text-success'>Purchase Order Detail : </h3>
                  </th>
                </tr>
                <tr>
                  <th>Po Number</th>
                  <th>Shipment Reference</th>
                  <th>Shipment Status</th>
                  <th>Shopname</th>
                  <th>Delivered Ware house</th>
                </tr>
                {moredetail().maindata}
                <tr>
                  <th colSpan={7}><h3 className='text-success'>Order Details : </h3></th>

                </tr>
                <tr>
                  <th>Component</th>
                  <th>Quantity</th>
                  <th>Unit price</th>
                  <th>Total cost</th>
                  <th>Damaged Qty</th>
                  <th>Actual Qty</th>
                  <th>Action</th>
                </tr>
                {moredetail().items}

              </tbody>
            </table>
          </div>
        </Dialog>


        <Dialog visible={shipmentpopup} position='top' modal style={{ width: '78rem' }} onHide={() => { if (!visible) return; setshipmentpopup(false); }}>
          <div class="container">
            <table className=' table-bordered'>
              <tbody>
                <tr>
                  <th colSpan={4}>
                    <p className='text-success'>Purchase Order Detail : </p>
                    <p>{componentdetail?.component}</p>
                  </th>
                </tr>
                <tr>
                  <th>Po Number</th>
                  <td>{componentdetail?.ponumber}</td>

                  <th>Shipment Status</th>
                  <td> <Shipmentstatus status={componentdetail?.shipment_status} /></td>
                </tr>
                <tr>
                  <th>Shipment Ref</th>
                  <td>{componentdetail?.shipment_reference}</td>

                  <th>Total Quantity</th>
                  <td>{componentdetail?.quantity}</td>
                </tr>
                <tr>
                </tr>
                <tr>
                  <td colspan={4}>
                    <p className='text-warning'>Update Damaged Stock (if any): </p>
                    <Formik
                      initialValues={{
                        actualquantity: componentdetail?.actualquantity,
                        damaged_quantity: componentdetail?.damaged_quantity,
                        stock_type: componentdetail?.stock_type,
                        damage_reason: componentdetail?.damage_reason,
                        damage_comment: componentdetail?.damage_comment,
                        purchase_order_id: componentdetail?.ponumber,
                        product_sku: componentdetail?.componentSkuCode,
                        unit: componentdetail?.unit,
                        supplier_id: componentdetail?.supplier
                      }}
                      enableReinitialize={true}

                      onSubmit={async (values) => {
                        console.log(values);
                        handleSave(values);
                      }}
                    >
                      {({ handleChange, setFieldValue, values }) => (
                        <Form>
                          <div className='row'>
                            <div className="col-md-4 form-group">
                              <label>Actual Quantity</label>
                              <Field type="number"
                                name="actualquantity"
                                className="form-control"
                                disabled
                              />
                            </div>

                            <div className="col-md-4 form-group">
                              <label>Stock type (if any)</label>
                              <Field
                                as="select"
                                className="form-control"
                                name="stock_type"
                              >
                                <option>Select status</option>
                                <option value={'damaged'}>Damaged</option>
                                <option value={'expired'}>Expired</option>
                              </Field>

                            </div>

                            <div className="col-md-4 form-group">
                              <label>Damaged Reason (if any)</label>
                              <Field
                                as="select"
                                className="form-control"
                                name="damage_reason"
                              >
                                <option value="">Select status</option>
                                <option value="leakage">Leakage</option>
                                <option value="broken_seal">Broken Seal</option>
                                <option value="container_damaged">Container Damaged</option>
                                <option value="spillage">Spillage</option>
                                <option value="expired">Expired</option>
                                <option value="partially_damaged">Partially Damaged</option>
                              </Field>
                            </div>

                            <div className="col-md-4 form-group">
                              <label>Damaged Quantity (if any)</label>
                              <Field type="number"
                                name="damaged_quantity"
                                onChange={(e) => {
                                  // console.log(typeof e.target.value);
                                  // console.log(typeof componentdetail.quantity);
                                  // if(e.target.value < componentdetail.quantity){
                                  setFieldValue('damaged_quantity', e.target.value);
                                  let value = e.target.value;
                                  let total_qty = componentdetail?.quantity;
                                  let remainqty = (total_qty - value);
                                  setFieldValue('actualquantity', remainqty);
                                  //  }
                                }}
                                className="form-control" />
                            </div>



                            <div className="col-md-12 form-group">
                              <label>Damaged Comment</label>
                              <Field
                                as="textarea"
                                type="text"
                                className="form-control"
                                name="damage_comment"
                              />
                            </div>

                            {/* <div className="col-md-6"></div>          */}
                            <div className="col-md-6">
                              <button type="submit" className='btn btn-success'>Save</button>
                            </div>

                          </div>
                        </Form>
                      )}
                    </Formik>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Dialog>

        <Confirmdelete2 popvisible={confirmarchivestate.popvisible} deletefun={deletepurchaseorder} id={confirmarchivestate.id} cancel={Cancel}/>

        {/* <Titlebar text={'Purchase Order'} /> */}
        <div className="col-md-12 mt-3">
          <div className='row'>
            <div className='col-md-9'>
              <TabMenu model={items} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} />
            </div>
            <div className='col-md-3'>
              <div>
                <button class="export-btn form-control w-50 pull-right" onClick={() => handleExport()}>
                  <i className='fa fa-file-excel'></i> &nbsp;Export to Excel</button>
              </div>
            </div>
          </div>
          {message()}
        
                       
          <div className='card'>
            <div className='card-body card-body-style'>
              <Formik
                initialValues={{}}
                enableReinitialize={true}
                onSubmit={async (values) => {
                  setfilter({ fromdate: values.fromdate, todate: values.todate });
                }}
              >
                <Form>
                  <div className='flex-box pb-3'>
                    <div className='flex-box flex-column date-box-style pb-2'>
                      <div className='pb-2 primary-text-color'><label>From date</label> </div>
                      <Field type="date" name="fromdate" placeholder='From date' className='primary-text-color date-input-style' />
                    </div>
                    &nbsp;
                    &nbsp;
                    &nbsp;


                    <div className='flex-box flex-column date-box-style pb-2'>
                      <div className='pb-2 primary-text-color'><label>To date</label> </div>
                      <Field type="date" name="todate" placeholder='To date' className='primary-text-color date-input-style' />
                    </div>
                    &nbsp;
                    &nbsp;

                    <div className='date-box'>
                      <button type='submit' className='btn-success text-white'>Filter</button>
                    </div>
                  </div>
                </Form>
              </Formik>
             
              <Tablescom rowdata={results} coldefs={colDefs} isloaded={userloaded} quickFilterText={quickFilterText} getRowClass={getRowClass} paginationPageSize={pageSize} onPaginationChanged={onPaginationChanged}
                totalRows={totalRows} currentPage={currentPage} pageSize={pageSize} handleNext={handleNext}
                handlePrevious={handlePrevious}
                handlePageSizeChange={handlePageSizeChange} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Purchaseorder;
